import { useQuery, useMutation } from 'convex/react';
import { api } from '@convex/_generated/api';
import { useCallback } from 'react';
import { toast } from 'sonner';

export function useAiReplyDrafts(
  contactIdentifier?: string,
  platform?: 'telegram' | 'whatsapp' | 'gmail'
) {
  const pendingDraft = useQuery(
    api['aiReply/drafts'].getForContact,
    contactIdentifier && platform ? { contactIdentifier, platform } : 'skip'
  );
  const pendingCount = useQuery(api['aiReply/drafts'].pendingCount);
  const cancelDraft = useMutation(api['aiReply/drafts'].cancel);
  const markDraftSent = useMutation(api['aiReply/drafts'].markSent);

  const handleCancel = useCallback(
    async (draftId: Parameters<typeof cancelDraft>[0]['draftId']) => {
      try {
        await cancelDraft({ draftId });
        toast.success('Draft cancelled');
      } catch {
        toast.error('Failed to cancel draft');
      }
    },
    [cancelDraft]
  );

  const handleMarkSent = useCallback(
    async (
      draftId: Parameters<typeof markDraftSent>[0]['draftId'],
      editedText?: string
    ) => {
      try {
        await markDraftSent({ draftId, editedText });
      } catch {
        toast.error('Failed to update draft status');
      }
    },
    [markDraftSent]
  );

  return {
    pendingDraft: pendingDraft ?? null,
    pendingCount: pendingCount ?? 0,
    handleCancel,
    handleMarkSent,
    isLoading: pendingDraft === undefined,
  };
}
